module.exports = __webpack_public_path__ + "static/media/sales-stream.eb73c5fa.svg";